<template>
  <div
    class="ag-grid__overlay-form-box"
  >
    <div
      v-t="'ADJUST_CALL_PAYMENTS'"
      class="ag-grid__overlay-form-box-title"
    />
    
    <div class="p-15">
      <div
        v-if="!callsReviewed && selectedCalls.length"
        class="col-md-offset-3"
      >
        <BulkCallDetails
          :key="bulkCallReviewKey"
          :selected-calls="selectedCalls"
          @unselectCallOnBulkAction="unselectCallOnBulkAction"
        />
  
        <div>
          <button
            v-t="'CONTINUE'"
            class="btn btn-primary btn-sm m-t-15"
            @click="callsReviewed = true"
          />
  
          <button
            v-t="'CANCEL'"
            class="btn btn-danger btn-sm m-t-15 m-l-10"
            @click="hideBulkForm"
          />
        </div>
      </div>

      <div v-if="callsReviewed || !selectedCalls.length">
        <span
          v-if="selectedCalls.length"
          class="clickable"
          @click="callsReviewed = false"
        >
          <i class="fa fa-chevron-left m-r-5" />
          {{ $t('REVIEW_CALLS') }}
        </span>
      
        <div class="container-fluid">
          <CallPaymentOverrideForm
            :is-admin="isAdmin"
            :is-bulk-adjustment="true"
            :selected-calls-count="selectedCalls.length"
            :total-calls-count="totalCallsCount"
            :pending-bulk-call-adjustment-by-logs="pendingBulkCallAdjustmentByLogs"
            @closeForm="hideBulkForm"
            @callPaymentAdjustmentSubmit="callPaymentAdjustmentSubmit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment-timezone';
import { reportingService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { mapGetters } from 'vuex';

import messages from './locales';
import sharedMessages from '@/core/locales';
import BulkCallDetails from '../BulkCallDetails';
import CallPaymentOverrideForm from '../CallPaymentOverrideForm';
import bulkCallActionMixin from './mixins/bulkCallActionMixin';

export default {
  name: 'BulkCallAdjustmentForm',

  components: {
    BulkCallDetails,
    CallPaymentOverrideForm,
  },

  mixins: [bulkCallActionMixin],

  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    totalCallsCount: {
      type: Number,
      default() {
        return null;
      }
    },
    recentTags: {
      type: Array,
      default() {
        return [];
      }
    },
    pendingBulkCallAdjustmentByLogs: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('reporting', [
      'activeCallLogTimeRange',
      'activeCallLogTranslatedTimeZoneId',
      'activeCallLogFilterCriteria',
      'activeCallLogLastUpdated'
    ]),
  },
  methods: {
    callPaymentAdjustmentSubmit(data) {
      const reportDateRange = reportingService.getReportingDateRange(this.activeCallLogTimeRange, this.activeCallLogTranslatedTimeZoneId);
      const reportFilters = [
        ...reportingService.getFilterFromFilterCriteria(this.activeCallLogFilterCriteria)
      ];
      const callIds = this.selectedCalls.length ? this.selectedCalls.map(call => call.inboundCallId) : null;
      const callLogs = {
        reportStart: reportDateRange.reportStart,
        reportEnd: reportDateRange.reportEnd,
        reportRequestTime: moment.tz(this.activeCallLogLastUpdated, this.activeCallLogTranslatedTimeZoneId).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        totalRequestedCount: this.totalCallsCount,
        formatTimeZone: this.activeCallLogTranslatedTimeZoneId,
        filters: reportFilters
      };

      // Temporary workaround for API requiring a value if boolean partner is false
      if (!data.adjustConversion) data.conversionAdjustmentAmount = 0;
      if (!data.adjustPayout) data.payoutAdjustmentAmount = 0;

      if (callIds) {
        // Request to endpoint sending callIds
        this.$emit('bulkCallAdjustment', { 
          callIds: callIds,
          data
        });
      } else {
        // Request to endpoint sending report query
        this.$emit('bulkCallAdjustmentByLogs', { 
          callLogs: callLogs,
          data
        });
      }
    }
  },

  i18n: {
    locale: 'en',
    messages,
    sharedMessages
  }
};
</script>

<style>

</style>